/* tslint:disable */
/* eslint-disable */
/**
 * WeighMed Backend APIs - OpenAPI 3.0
 * You can find out more about Swagger at [https://editor.swagger.io/](https://editor.swagger.io/).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const VNotificationTypeEnum = {
    CaddyBatteryLow: 'Caddy Battery Low',
    CaddyBatteryCritical: 'Caddy Battery Critical',
    CaddyTemperatureLow: 'Caddy Temperature Low',
    TankWeightLow: 'Tank Weight Low',
    TankWeightHigh: 'Tank Weight High',
    TankWeightLossFast: 'Tank Weight Loss Fast',
    TankWeightLossCritical: 'Tank Weight Loss Critical',
    TankEvaporationRateLow: 'Tank Evaporation Rate Low',
    TankEvaporationRateHigh: 'Tank Evaporation Rate High',
    TankMuted: 'Tank Muted',
    TankOffline: 'Tank Offline',
    CaddyBatteryLowSnoozed: 'Caddy Battery Low Snoozed',
    CaddyBatteryCriticalSnoozed: 'Caddy Battery Critical Snoozed',
    CaddyTemperatureLowSnoozed: 'Caddy Temperature Low Snoozed',
    TankWeightLowSnoozed: 'Tank Weight Low Snoozed',
    TankWeightHighSnoozed: 'Tank Weight High Snoozed',
    TankEvaporationRateLowSnoozed: 'Tank Evaporation Rate Low Snoozed',
    TankEvaporationRateHighSnoozed: 'Tank Evaporation Rate High Snoozed',
    TankWeightLossFastSnoozed: 'Tank Weight Loss Fast Snoozed',
    TankWeightLossCriticalSnoozed: 'Tank Weight Loss Critical Snoozed',
    TankConfigSynced: 'Tank Config Synced',
    CaddyConfigSynced: 'Caddy Config Synced'
} as const;
export type VNotificationTypeEnum = typeof VNotificationTypeEnum[keyof typeof VNotificationTypeEnum];


export function VNotificationTypeEnumFromJSON(json: any): VNotificationTypeEnum {
    return VNotificationTypeEnumFromJSONTyped(json, false);
}

export function VNotificationTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): VNotificationTypeEnum {
    return json as VNotificationTypeEnum;
}

export function VNotificationTypeEnumToJSON(value?: VNotificationTypeEnum | null): any {
    return value as any;
}

